import { render, staticRenderFns } from "./debateCard.vue?vue&type=template&id=59038f64&scoped=true&"
import script from "./debateCard.vue?vue&type=script&lang=js&"
export * from "./debateCard.vue?vue&type=script&lang=js&"
import style0 from "./debateCard.vue?vue&type=style&index=0&id=59038f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59038f64",
  null
  
)

export default component.exports